import PortalLayout from './PortalLayout.vue';

export { PortalLayout };
